import { createRoot, Root } from "react-dom/client";
import { ensureNotNil } from "client/Misc/utils";
import {
	TermsNoticeKind,
	userConfiguration
} from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { TermsNoticeDialog } from "./TermsNoticeDialog";

export function init(): void {
	const kind: TermsNoticeKind = userConfiguration().termsNotice;

	if (kind === TermsNoticeKind.None) {
		return;
	}

	const element: HTMLElement = ensureNotNil(
		document.getElementById("terms-notice-host")
	);

	const root: Root = createRoot(element);

	root.render(
		<TermsNoticeDialog
			kind={kind}
			onDismissed={() => root.unmount()}
		/>
	);
}
